module.exports = __webpack_public_path__ + "static/determined-site-header-urbanindiancenter-ef4a054f115d87b994e38de6280bdecb.jpg";